import { HelmetProvider } from 'react-helmet-async';
import { SessionProvider } from '~/components/contexts/SessionProvider';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { resources } from '~/locale';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '~/services';
import 'moment/dist/locale/es';
import { initializeGA } from '~/lib/analytics';
import { Router } from '../router/Router';
import { useEffect } from 'react';
import { DetectAndSetTheme } from '../shared/Theme';
import 'react-phone-number-input/style.css';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
// Import theme test console for development
import '../shared/ThemeTestConsole';
import { Provider } from 'react-redux';
import { store } from '~/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
// import { persistor } from '~/store';
// import { PersistGate } from 'redux-persist/integration/react';

if (true) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'es',
  resources,
});

initializeGA();

export const App = () => {
  useEffect(() => {
    (window as any).fbAsyncInit = function () {
      // @ts-ignore
      FB.init({
        appId: import.meta.env.VITE_FB_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v22.0',
      });
    };

    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.defer = true;
    fbScript.src = 'https://connect.facebook.net/en_US/sdk.js';
    document.body.appendChild(fbScript);
  }, []);

  DetectAndSetTheme();

  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  if (!googleClientId) {
    console.warn(
      'VITE_GOOGLE_CLIENT_ID is not set. Google OAuth will not work.',
    );
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId || ''}>
      <I18nextProvider i18n={i18next} defaultNS={'translation'}>
        <Provider store={store}>
          {/* <PersistGate loading={null} persistor={persistor}> */}
          <ApolloProvider client={apolloClient}>
            <HelmetProvider>
              <SessionProvider>
                <Router />
              </SessionProvider>
            </HelmetProvider>
          </ApolloProvider>
          {/* </PersistGate> */}
        </Provider>
      </I18nextProvider>
    </GoogleOAuthProvider>
  );
};
